import { useContext, useRef } from 'react'

import { TextField } from '@material-ui/core'

import ContentModalContext from '../../ContentModalProvider/Context'
import ValidationMessage from '../../components/ValidationMessage'
import { ERROR_MESSAGES, FIELD_NAMES, LABELS } from '../../components/constants'

const fieldName = FIELD_NAMES.TITLE
const label = LABELS.TITLE
const id = 'content-item-title-required-message'

const Title = () => {
  const { item, onUpdateField, validation } = useContext(ContentModalContext)

  const touchedRef = useRef(false)
  const touched = touchedRef.current
  const value = item[fieldName]

  return (
    <div>
      <TextField
        id={FIELD_NAMES.TITLE}
        fullWidth
        variant="outlined"
        label={label}
        required
        error={touched && !!validation.getHasError(label)}
        placeholder={label}
        autoFocus
        value={value}
        aria-describedby={id}
        onChange={(e) => {
          touchedRef.current = true
          onUpdateField(fieldName, e.target.value)
        }}
      />
      <ValidationMessage
        id={id}
        label={label}
        touched={touched}
        valuesByError={{
          [ERROR_MESSAGES.REQUIRED]: value,
        }}
      />
    </div>
  )
}

export default Title
